<template>
  <!-- R2 版本 删除部分内容， 原有文件见 IndexOld.vue -->
  <div class="project-table" id="project-table" style="padding: 0; margin-top:  -16px;">
    <!-- 顶部操作区域 -->
    <div class="content--options" id="content--options">
      <div class="list">
        <router-link class="go-back" to="/manage/members/deleted">
          <i class="r2-icon-hardware_keyboard_backspace_outlined"></i>{{userName}}
        </router-link>

        <!-- 列表/缩略图 切换 -->
        <operation-module-type
          :can-sort="false"
          :current-sort="sortFieldName + ',' + sortType"
          @change="moduleTypeQueryList"
          class="float_right"
          :selectedType="typeFilterData">
        </operation-module-type>

        <!-- 搜索 -->
        <operation-search
          v-if="tabletype !== 'projectList'"
          class="float_right margin-left-10"
          @onSearch="searchHandle">
        </operation-search>

        <!-- 批量操作按钮 -->
        <template v-if="checkedLen">
          <w-button size="small"
                    class="float_right"
                    style="margin-left: 16px; margin-right: 6px"
                    @click.native="copyFilesTap()"
                    type="primary">
            复制到共享空间
          </w-button>
          <w-button plain size="small"
                    class="float_right"
                    @click.native="downloadFiles()"
                    type="default">
            下载
          </w-button>
        </template>
      </div>
      <div class="list">
        <!-- 面包屑 -->
        <operation-crumb :items="pathItems" @change="queryPathList"></operation-crumb>
      </div>
    </div>
    <div class="dndCnt">
      <div class="tabcnt" id="projectTabCnt">
        <!-- 列表形式 展示 -->
        <table-base v-if="typeFilterData === 'list'"
               :height="tableHeight"
               :fixedTable="true"
               :showNoData="dataList.length === 0"
               no-data-text="还没有上传文件"
               v-loading="loading"
               element-loading-background="rgba(255, 255, 255, 0.8)">
          <thead slot="header">
            <tr>
              <th width="240" class="checkAllth">
                <label class="checkall-label">
                  <w-checkbox @change="checkAll" v-model="isCheckAll"></w-checkbox>
                </label>
                <span>
                  名称
                </span>
              </th>
              <th width="80">
                <span>
                  修改时间
                </span>
              </th>
              <th width="80">创建时间</th>
              <th width="80">
                <span>
                  文件大小
                </span>
              </th>
              <th width="40" class="is-operate">操作</th>
            </tr>
          </thead>
          <tbody slot="body">
            <template v-for="(item,index) in dataList">
              <tr v-if="item.fileType !== 'share'"
                  :key="'tr_' + index + refreshIndex"
                  height="40"
                  @click="trClick(index, item)"
                  :class="['trItem', item.checked ? 'active trItem' : '']"
                  @mouseenter="trMouseEnter(item, index)"
                  @mouseleave="trMouseLeave(item)">
                <td width="240">
                  <div class="l-boxd">
                    <label :class="['w__checkbox', item.checked ? 'is-checked' : '']" style="margin-right: 0;">
                    <span class="w__checkbox__input" :class="{'is-checked': item.checked}">
                      <span class="w__checkbox__inner" @click.stop.prevent="trClick(index, item)"></span>
                      <input type="checkbox" class="w__checkbox__original" value="">
                    </span>
                    </label>
                    <div class="personHover l-boxd-d">
                      <i :class="['file-icons', item.suffix === 'gtjxt' ? '' : 'icon_' + item.suffix, 'icon_' + item.fileProperties.projectType, item.folder ? 'folder' : '']"
                         @mouseenter="personTextBoxStyleHandle(index);"
                         @mouseleave="iconHoverIndex = -1"
                         @click.stop="nameClick(item)">
                      </i>
                      <span class="file-name"
                            style="cursor: default; text-decoration: none; color: #333;"
                            v-on:click.stop="nameClick(item)"
                            :title="item.name">
                          {{item.name}}
                      </span>
                      <w-tag v-if="item.fileType == 1 && item.fileProperties.region"
                             style="color: rgba(33,37,48,0.55);border-color: rgba(222,223,224,1);"
                             class="margin-left-10"
                             size="mini" around>
                        {{item.fileProperties.region}}
                      </w-tag>
                      <div v-if="!item.folder" class="person-textbox" v-show="iconHoverIndex === index">
                        <p>创建时间：{{item.createTime}}</p>
                        <p>文件大小：{{item.size}}</p>
                        <template v-if="+item.fileType == 1">
                          <p>
                            文件类型：
                            <template v-if="+item.extraInfo === 1">概算</template>
                            <template v-else-if="+item.extraInfo === 2">预算</template>
                            <template v-else-if="+item.extraInfo === 3">结算</template>
                            <template v-else>审核</template>
                          </p>
                        </template>
                        <template v-if="+item.fileType == 2">
                          <p>
                            <label>工程类别：</label>
                            {{item.fileProperties.projectCategory || '【无】'}}
                          </p>
                          <p>
                            <label>结构类型：</label>
                            {{item.fileProperties.structureCategory || '【无】'}}
                          </p>
                          <p>
                            <label>清单规则：</label>
                            {{item.fileProperties.listRule || '【无】'}}
                          </p>
                          <p>
                            <label>定额规则：</label>
                            {{item.fileProperties.quotaRule || '【无】'}}
                          </p>
                        </template>
                      </div>
                    </div>
                  </div>
                </td>
                <td width="80">{{item.modifyTime}}</td>
                <td width="80">{{item.createTime}}</td>
                <td width="80">{{item.folder ? '' : item.size}}</td>
                <td width="40" class="is-operate" :key="index + '_icon_' + iconListKey">
                  <div class="operation operation_cont">
                    <el-tooltip content="下载">
                      <a class="w-icon-xiazai1" v-on:click.stop="downloadFile(item)"></a>
                    </el-tooltip>
                    <el-tooltip content="复制到共享空间">
                      <a class="r2-icon-content_copy" v-on:click.stop="copyFilesTap(item)"></a>
                    </el-tooltip>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table-base>
        <!-- 缩略图模式 展示 -->
        <div v-else class="listcnt" :style="{height: tableHeight + 50 + 'px'}">
          <div class="imgItem-checkall">
            <label class="checkall-label">
              <w-checkbox @change="checkAll" v-model="isCheckAll">全选</w-checkbox>
            </label>
          </div>
          <template v-for="(item,index) in dataList">
            <div v-if="item.fileType !== 'share'"
                 class="size_96 thumbnail-item relative"
                 :class="[item.checked ? 'active trItem imgItem' : 'trItem imgItem']"
                 :key="'tr_' + index + refreshIndex"
                 @mouseenter="trMouseEnter(item,index)"
                 @mouseleave="trMouseLeave(item)">
              <div class="absolute more" style="right: 5px; top: 2px;z-index: 9;">
                <w-dropdown @command="handlerAction" trigger="click">
                <span class="w__dropdown-link" @click.stop="_clickHandle(item, index)">
                   <span class="more"><i class="r2-icon-nav_more_vert" style="font-size: 16px !important;"></i></span>
                </span>
                  <w-dropdown-menu :visibleArrow="false" slot="dropdown">
                    <w-dropdown-item :command="{item, fn: 'downloadFile'}">下载</w-dropdown-item>
                    <w-dropdown-item :command="{item, fn: 'copyFilesTap'}">复制到共享空间</w-dropdown-item>
                  </w-dropdown-menu>
                </w-dropdown>
              </div>
              <label role="checkbox" aria-checked="true" class="w__checkbox imgItem-checkbox"
                     :class="{'is-checked': item.checked}"
                     @click.stop="checkboxTap(item, index, $event)">
                <span aria-checked="mixed" class="w__checkbox__input" :class="{'is-checked': item.checked}">
                  <span class="w__checkbox__inner"></span>
                  <input type="checkbox" aria-hidden="true" class="w__checkbox__original" value="">
                </span>
              </label>
              <div class="imgItem-box">
                <template v-if="item.thumbnailUrl">
                  <img :src="item.thumbnailUrl"
                       @mouseenter="personTextBoxStyleHandle(index);"
                       @mouseleave="iconHoverIndex = -1"
                       @click.stop="nameClick(item)"/>
                </template>
                <template v-else>
                  <i :class="['file-icons', 'icon_' + item.suffix, 'icon_' + item.fileProperties.projectType, item.folder ? (item.fileType === 'share' ? 'folder__share' : 'folder') : '']"
                     @mouseenter="personTextBoxStyleHandle(index);"
                     @mouseleave="iconHoverIndex = -1"
                     @click.stop="nameClick(item)">
                  </i>
                </template>
                <div v-if="!item.folder" class="person-textbox" v-show="iconHoverIndex === index">
                  <p>创建时间：{{item.createTime}}</p>
                  <p>文件大小：{{item.size}}</p>
                  <template v-if="+item.fileType === 1">
                    <p>
                      文件类型：
                      <template v-if="+item.extraInfo === 1">概算</template>
                      <template v-else-if="+item.extraInfo === 2">预算</template>
                      <template v-else-if="+item.extraInfo === 3">结算</template>
                      <template v-else>审核</template>
                    </p>
                  </template>
                  <template v-if="+item.fileType === 2">
                    <p>
                      <label>工程类别：</label>
                      {{item.fileProperties.projectCategory || '【无】'}}
                    </p>
                    <p>
                      <label>结构类型：</label>
                      {{item.fileProperties.structureCategory || '【无】'}}
                    </p>
                    <p>
                      <label>清单规则：</label>
                      {{item.fileProperties.listRule || '【无】'}}
                    </p>
                    <p>
                      <label>定额规则：</label>
                      {{item.fileProperties.quotaRule || '【无】'}}
                    </p>
                  </template>
                </div>
              </div>
              <div class="imgItem-name">
                <span class="imgItem-name-a" style="cursor: default;"
                   v-on:click.stop="nameClick(item)"
                   :title="item.name">
                  {{item.name}}
                </span>
              </div>
              <div class="imgItem-filetime">{{item.modifyTime}}</div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <!-- 右键菜单 -->
    <ul class="contextMenu" v-show="contextMenuShow">
      <li @click="downloadFiles()">下载</li>
      <li @click="copyFilesTap()">复制到共享空间</li>
    </ul>
    <!-- 分页 -->
    <div class="page-box" v-if="total > 0">
      <w-pagination
        @current-change="handleCurrentChange"
        @size-change="handlePageSizeChange"
        :current-page.sync="pageNum"
        background
        layout="total, prev, pager, next, jumper,sizes"
        :page-size="pageSize"
        :page-sizes="[50, 100]"
        :total="total">
      </w-pagination>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-useless-escape,no-unused-vars */
import {backendUrl} from '@/assets/js/config'
import {sizeConver, formatDay, capitalize, clone, formatDuration} from '@/assets/utils'
import {on, off} from '@zjy/zjy-ui/lib/utils/dom'
import TableBase from '_c/common/Table/Index.vue'
import {mapState, mapMutations} from 'vuex'
import {getCookie} from '@/assets/utils/CommonUtil'
import {getFileTyeIconClass} from '@/assets/utils/space'
import SpaceService from '@/assets/service/space'
import {
  OperationCrumb,
  OperationModuleType,
  OperationSearch
} from '@/components/common'
import _ from 'lodash'

let isOnShift // 是否长按shift
let clickIndex // 数据点击Index
let trIsMouseEnter // 鼠标是否在数据上
let downLoadTimer // 删除文件列表
let copyFilesPath = []
let nameClickTimer
export default {
  name: 'StaffFiles',
  components: {
    TableBase,
    OperationCrumb,
    OperationModuleType,
    OperationSearch
  },
  data () {
    return {
      typeFilterData: 'list',
      // 文件筛选类型
      fileType: 0,
      // 右键
      contextMenuShow: false,
      isCheckAll: false,
      // 选择文件数量
      checkedLen: 0,
      // 列表数据
      loading: false,
      dataList: [],
      refreshIndex: 0,
      // 排序规则  倒叙 1  顺序 0
      sortType: 1,
      // 排序字段
      sortFieldName: 'modifiedTime',
      // 搜索值
      searchVal: '',
      // 当前路径
      path: '/',
      pageNum: 1,
      pageSize: 50,
      total: 0,
      pathItems: [
        {
          // link: 'http://www.glodon.com', // 情况一: 外部链接 优先级最高 可选
          // path: '/vip', //  情况二: 系统内路由跳转 可选
          // params: {}, //  情况二:  系统内路由跳转 参数 可选
          name: '全部文件' // 情况三: 只包含name字段 则触发父组件toFolder(文件夹路径)
        }
      ],
      iconHoverIndex: -1, //
      user: {}
    }
  },
  props: {
    tabletype: {
      type: String,
      default: 'personalList'
    }
  },
  computed: {
    ...mapState({
      // personalList: state => state.space.personalList,
      workspace: state => state.space.workspace,
      personalFilter: state => state.spacefilter.personalFilter,
      enterpriseFilter: state => state.spacefilter.enterpriseFilter,
      projectFilter: state => state.spacefilter.projectFilter,
      guideType: state => state.user.user.guideType
    }),
    // 已删除用户 用户名
    userName () {
      return (this.$route.query.name || '')
    }
  },
  watch: {
    dataList: function () {
      this.setContextmenuStatusAndTopButtons()
    }
  },
  methods: {
    ...mapMutations({
      setPersonalTypeFilter: 'spacefilter/SET_PERSONAL_FILTER',
      setEnterproseTypeFilter: 'spacefilter/SET_ENTERPRISE_FILTER',
      setProjectTypeFilter: 'spacefilter/SET_PROJECT_FILTER'
    }),
    // 计算表格高度
    calcTableHeight () {
      this.tableHeight = this.getTableHeight('project-table') - this.getTableHeight('content--options') - (this.total > 0 ? 130 : 80)
    },
    // 更改页码
    handleCurrentChange (index) {
      this.pageNum = index
      initData(this, true)
    },
    // 更改每一页显示条数
    handlePageSizeChange (index) {
      this.pageSize = index
      this.pageNum = 1
      initData(this, true)
    },
    // 将 val 全部转换成小写
    capitalize (val) {
      return capitalize(val, true, true)
    },
    // 全选
    checkAll () {
      let dataList = [...this.dataList]
      dataList = dataList.map(item => {
        item.checked = this.isCheckAll
        return {
          ...item
        }
      })
      this.dataList = dataList
    },
    // 缩略图模式 每一项 前面的复选框 点击
    checkboxTap (item, index, e) {
      e.preventDefault()
      e.stopPropagation()
      this.$set(this.dataList[index], 'checked', !item.checked)
      let isCheckAll = true
      this.dataList.forEach(tr => {
        if (!tr.checked) {
          isCheckAll = false
        }
      })
      this.isCheckAll = isCheckAll
      this.refreshIndex++
      // 设置 右键菜单 和 顶部操作按钮组
      this.setContextmenuStatusAndTopButtons()
    },
    // 缩略图模式下 每一项右上角 三个小点 点击
    _clickHandle (item, trIsMouseEnter) {
      let _self = this
      _self.contextMenuShow = false
      if (trIsMouseEnter > -1) {
        let dataList = JSON.parse(JSON.stringify(_self.dataList))
        if (!dataList[trIsMouseEnter].checked) {
          dataList.forEach((item, index) => {
            if (trIsMouseEnter === index) {
              item.checked = true
            } else {
              item.checked = false
            }
          })
          _self.dataList = dataList
        }
      }
    },
    // 缩略图-更多操作，下拉菜单
    handlerAction ({item, fn, type}) {
      this[fn](item)
    },
    trMouseEnter (item, index) {
      trIsMouseEnter = index
    },
    trMouseLeave () {
      trIsMouseEnter = -1
    },
    // 单行选中
    trClick (index, item) {
      let dataobj = {...this.dataList[index]}
      this.contextMenuShow = false
      dataobj.checked = !dataobj.checked
      if (isOnShift) {
        if (clickIndex === undefined) {
          return
        }
        let dataList = [...this.dataList]
        dataList = dataList.map((item, itemindex) => {
          if (clickIndex >= index) {
            if (itemindex >= index && itemindex <= clickIndex) {
              item.checked = true
            } else {
              item.checked = false
            }
          } else if (clickIndex < index) {
            if (itemindex <= index && itemindex >= clickIndex) {
              item.checked = true
            } else {
              item.checked = false
            }
          }
          return {
            ...item
          }
        })
        this.dataList = dataList
      } else {
        clickIndex = index
        this.dataList.splice(index, 1, dataobj)
      }
      let isCheckAll = true
      this.dataList.forEach(tr => {
        if (!tr.checked) {
          isCheckAll = false
        }
      })
      this.isCheckAll = isCheckAll
    },
    // 下载单文件
    downloadFile (item) {
      if (item.folder) {
        this.downloadFiles([item])
        return
      }
      this.sentLog(100117037)
      let path = item.path
      path = encodeURIComponent(path)
      let token = getCookie('ZJYTOKEN')
      let workspaceId = getWorkspaceId(this)
      this.addOperationRecords(1, item)
      window.common.downloadFile(
        `${backendUrl}/file/download?path=${path}&token=${token}&workspaceId=${workspaceId}`
      )
    },
    // 下载多文件
    downloadFiles (downItems) {
      this.sentLog(100117037)
      let list = downItems || this.dataList.filter(item => item.checked)
      if (list.length === 0) {
        return
      }
      this.contextMenuShow = false
      let filePathListm = []
      let folderPathList = []
      let workspaceId = getWorkspaceId(this)
      list.map(item => {
        if (item.folder) {
          if (item.path !== null) {
            folderPathList.push(item.path)
          }
        } else {
          filePathListm.push(item.path)
        }
      })
      let parameter = {
        filePathListm,
        folderPathList,
        workspaceId
      }
      SpaceService.downloadFiles(parameter).then(res => {
        if (+res.code === 200) {
          // 记录操作-下载
          this.addOperationRecords(1, list)
          if (res.data) {
            if (res.data.dataUrl) {
              getDownloadFilesState(this, res.data.dataUrl)
            } else {
              this.$message.warning('文件夹是空')
            }
          }
        } else if (+res.code === 403) {
        }
      })
    },
    // 名称点击
    nameClick (item) {
      this.contextMenuShow = false
      if (this.loading) return
      // 进入文件夹
      clearTimeout(nameClickTimer)
      nameClickTimer = setTimeout(() => {
        if (item.folder) {
          this.path = item.path
          this.dataList = []
          this.pathItems.push({
            name: item.name
          })
          initData(this)
        }
      }, 800)
    },
    // 面包屑点击
    queryPathList (data) {
      if (data.filepath === '/全部文件') {
        this.path = '/'
        this.pathItems = [{name: '全部文件'}]
      } else {
        this.path = data.filepath
        this.pathItems = data.items
      }
      initData(this)
    },
    // 获取列表是图片模式还是列表模式
    getTypeFilterData () {
      this.typeFilterData = this.personalFilter.listType
    },
    // 列表图片切换
    moduleTypeQueryList (data) {
      let typeFilterData = {...this.personalFilter}
      if (data.moduleType) {
        typeFilterData.listType = data.moduleType
        this.typeFilterData = data.moduleType
      }
      this.setPersonalTypeFilter(typeFilterData)
      this.sortFieldName = data.sortFieldName
      this.sortType = data.sortType
      initData(this)
    },
    // 复制到共享空间
    copyFilesTap (trItem) {
      console.log(trItem)
      if (trItem) {
        copyFilesPath = [trItem]
      } else {
        copyFilesPath = this.dataList.filter(item => item.checked)
      }
      this.contextMenuShow = false
      this.$confirm({
        message: '确定要把文件复制到共享空间吗？',
        type: 'primary',
        tips: '为了避免长时间等待，请每次操作少量文件.',
        submit: () => {
          this.sentLog(100117038)
          this.fileCopy()
        }
      })
    },
    // 拷贝
    fileCopy () {
      const ZJYTOKEN = getCookie('ZJYTOKEN')
      let sourceFileList = []
      let sourceFolderList = []
      let filesize = 0
      copyFilesPath.map(item => {
        if (item.folder) {
          if (item.path !== null) {
            sourceFolderList.push(item.path)
          }
        } else {
          if (item.length) {
            filesize += parseInt(item.length)
          }
          sourceFileList.push(item.path)
        }
      })
      this.checkCapacity(filesize).then(() => {
        const cacheKey = new Date().getTime() + '_' + ZJYTOKEN
        let parameter = {
          cacheKey,
          operationType: 2,
          paramType: 'filePath',
          sourceWorkspaceId: getWorkspaceId(this),
          targetFile: '/员工工程-' + this.$route.query.account || this.userName,
          targetWorkspaceId: getWorkspaceId(this, true),
          sourceFileList: sourceFileList,
          sourceFolderList: sourceFolderList
        }
        let taskComplete = 0
        let result = null
        const afterTask = () => {
          // 进度到100%、并且有有返回数据时执行
          if (taskComplete && result) {
            if (+result.code === 200 || (taskComplete > 1 && +result.code === -1)) {
              this.$message.success('已成功复制到共享空间')
              initData(this)
            } else {
              this.$message.error('复制到共享空间失败')
            }
            initData(this)
          }
        }
        SpaceService.fileCopy(parameter).then(res => {
          result = res
          afterTask()
        })
        this.getProgress('copy', '', 'COPY_FLAG_' + cacheKey, true).then(({hit}) => {
          taskComplete = hit
          afterTask()
        })
      })
    },
    // 校验容量
    checkCapacity (fileSize) {
      return new Promise((resolve, reject) => {
        let workspaceId = getCookie('enterpriseWorkspaceIdValue')
        fileSize = fileSize || 0
        SpaceService.getWorkspaceById({workspaceId}).then(data => {
          if (+data.code === 200) {
            let {totalCapacity, usedCapacity} = data.data
            usedCapacity = usedCapacity || 0
            totalCapacity = totalCapacity || 0
            if (parseInt(totalCapacity) > parseInt(usedCapacity) + parseInt(fileSize)) {
              resolve()
            } else {
              this.$message.info('企业共享空间容量不足，请您联系管理员进行扩容')
              reject(new Error('error log'))
            }
          }
        })
      })
    },
    // 搜索
    searchHandle: _.debounce(function (val = '') {
      this.searchVal = val
      initData(this)
    }, 500),
    // 图标hover
    personTextBoxStyleHandle (index) {
      handelTextBoxStyle(this)
      this.iconHoverIndex = index
    },
    // 10. 设置右键菜单列表状态 和 顶部操作按钮组
    setContextmenuStatusAndTopButtons () {
      this.checkedLen = this.dataList.filter(item => {
        return item.checked
      }).length
    }
  },
  beforeDestroy () {
    initEvent(this)
  },
  mounted () {
    setTimeout(() => {
      this.calcTableHeight()
    }, 200)
    // 窗口大小改变时 触发
    this.resizeHandle.resize(this.calcTableHeight)
    this.pathItems = [{name: '全部文件'}]
  },
  created () {
    let userinfo = getCookie('ZJYUSERINFO')
    if (userinfo) {
      userinfo = JSON.parse(userinfo)
      this.user = userinfo
    }
    // 初始化事件
    setTimeout(() => {
      initEvent(this, true)
    }, 100)
    initData(this, true)
    this.getTypeFilterData()
  }
}
const eventList = [
  'keydown',
  'keyup',
  'click'
]
const eventObj = {}
eventList.forEach((name) => {
  eventObj[name] = null
})

// 初始化事件
function initEvent (that, init) {
  // console.log('=============================', init)
  let _self = that
  // 先销毁事件
  eventList.forEach((name) => {
    if (eventObj[name]) {
      // console.log(name)
      off(document, name, eventObj[name])
      eventObj[name] = null
    }
  })
  if (!init) return
  eventObj.keydown = function (e) {
    if (e.keyCode === 16) {
      isOnShift = true
    }
  }
  on(document, 'keydown', eventObj.keydown)

  eventObj.keyup = function () {
    isOnShift = false
  }
  on(document, 'keyup', eventObj.keyup)

  // 如果右键菜单处于显示状态 点击页面任何区域 隐藏右键菜单
  eventObj.click = function () {
    if (_self.contextMenuShow) {
      _self.contextMenuShow = false
    }
  }
  on(document, 'click', eventObj.click)
  // 初始化 右键菜单事件
  setTimeout(() => {
    let trlistDom = document.querySelector('#projectTabCnt')
    on(trlistDom, 'contextmenu', function (e) {
      if (trIsMouseEnter > -1) {
        e = e || window.event
        e.stopPropagation()
        e.preventDefault()
        let _x = e.clientX || e.x
        let _y = e.clientY || e.y
        const tableWrapper = document.getElementById('project-table')
        const tableWrapperPosition = tableWrapper.getBoundingClientRect()
        let contextMenuDom = document.querySelector('.contextMenu')
        contextMenuDom.style.left = 'auto'
        contextMenuDom.style.right = 'auto'
        contextMenuDom.style.top = 'auto'
        contextMenuDom.style.bottom = 'auto'

        let maxWidth = document.body.clientWidth
        if (maxWidth - _x <= 130) {
          contextMenuDom.style.right = '30px'
        } else {
          contextMenuDom.style.left = _x - tableWrapperPosition.left + 30 + 'px'
        }
        let maxHeight = document.body.clientHeight
        if (maxHeight - _y <= 90) {
          contextMenuDom.style.bottom = '8px'
        } else {
          contextMenuDom.style.top = _y - tableWrapperPosition.top + 30 + 'px'
        }

        // contextMenuDom.style.left = _x + 10 + 'px'
        // contextMenuDom.style.top = _y + 10 + 'px'
        let dataList = JSON.parse(JSON.stringify(_self.dataList))
        let nowIcon = {}
        if (!dataList[trIsMouseEnter].checked) {
          dataList.forEach((item, index) => {
            if (trIsMouseEnter === index) {
              nowIcon = item
              item.checked = true
            } else {
              item.checked = false
            }
          })
          _self.dataList = dataList
        } else {
          nowIcon = dataList[trIsMouseEnter]
        }
        _self.$nextTick(() => {
          let checkedCount = 0
          dataList.forEach((item, index) => {
            if (item.checked) {
              checkedCount++
            }
          })
          setTimeout(() => {
            console.log(_self.contextMenuShow)
          }, 1000)
          _self.contextMenuShow = true
        })
      }
    })
  }, 200)
}


// 获取空间id
function getWorkspaceId (that, company) {
  if (that.tabletype === 'companyList' || company) {
    // 共享空间
    return getCookie('enterpriseWorkspaceIdValue')
  }
  if (that.tabletype === 'personalList') {
    // 员工/个人空间
    if (that.$route && that.$route.query && that.$route.query.workspaceId){
      return that.$route.query.workspaceId
    } else {
      return getCookie('personalWorkspaceIdValue')
    }
  }
}

// 初始化数据
function initData (that, resetPager) {
  // that.dataList = [];
  if (!resetPager) {
    that.pageNum = 1
    // that.pageSize = 50
    that.total = 0
  }
  let parameter = {
    path: that.path,
    workspaceId: getWorkspaceId(that),
    fileType: 0,
    sortFieldName: that.sortFieldName,
    sortType: that.sortType,
    pageNum: that.pageNum,
    pageSize: that.pageSize
  }
  let apiName = 'getFileList'
  if (that.searchVal) {
    apiName = 'getSearchFileList'
    parameter.searchCondition = `{
        name: ${that.searchVal}
      }`
  }
  // 个人空间、企业员工自己的空间 在根目录下 显示 我收到的分享工程 文件夹
  if (that.path === '/' && +that.user.role > 1 && that.tabletype === 'personalList') {
    parameter.needShare = true
  }
  that.loading = true
  SpaceService[apiName](parameter).then(res => {
    that.loading = false
    let data = res.data || {}
    let items = data.items || []
    let totalCount = data.totalCount || 0
    items.forEach(item => {
      item.size = sizeConver(item.length || 0)
      if (item.createTime) {
        item.createTime = formatDay(new Date(parseInt(item.createTime)))
      }
      if (item.modifyTime) {
        item.modifyTime = formatDay(new Date(parseInt(item.modifyTime)))
      }
      // 重要！！！ 我收到的分享工程文件夹 是虚拟文件夹 fileProperties 属性为 null 若不设置成对象 html 中会报错
      if (!item.fileProperties) {
        item.fileProperties = {}
      }
    })
    that.isCheckAll = false
    that.dataList = getFileTyeIconClass(items)
    that.total = totalCount
    that.calcTableHeight()
    setTimeout(() => {
      handelTextBoxStyle(that)
    }, 300)
  }).catch(() => {
    that.loading = false
  })
}


// 获取下载状态
function getDownloadFilesState (that, zipFileName) {
  SpaceService.getDownloadFilesState().then(res => {
    clearTimeout(downLoadTimer)
    if (+res.code === 200) {
      if (res.data >= 100) {
        setTimeout(() => {
          that.$progress({closeAll: true})
        }, 100)
        that.showProgress('正在下载文件...', +res.data)
        let token = getCookie('ZJYTOKEN')
        zipFileName = encodeURIComponent(zipFileName)
        window.common.downloadFile(
          `${backendUrl}/file/batch_download?zipFileName=${zipFileName}&token=${token}`
        )
      } else if (+res.data === -1) {
        that.$progress({
          closeAll: true,
          close: () => {
            that.$message.error('下载失败')
          }
        })
      } else {
        that.showProgress('正在下载文件...', +res.data)
        downLoadTimer = setTimeout(() => {
          getDownloadFilesState(that, zipFileName)
        }, 1000)
      }
    }
  })
}

// 设置每个文件 文件详情 小提示框位置
function handelTextBoxStyle (that) {
  let personTextboxAll
  if (that.typeFilterData === 'list') {
    personTextboxAll = document.querySelectorAll('.trItem')
  } else {
    personTextboxAll = document.querySelectorAll('.imgItem')
  }
  let w =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth
  let h =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight

  let tableBodyWrapper = that.typeFilterData === 'list' ? document.querySelector('.table-body-wrapper') : document.querySelector('.listcnt')
  let tablieBodyScrollTop = tableBodyWrapper ? tableBodyWrapper.scrollTop : 0
  for (let i = 0; i < personTextboxAll.length; i++) {
    if (personTextboxAll[i].querySelector('.person-textbox')) {
      if (that.typeFilterData === 'list') {
        if (personTextboxAll[i].offsetTop + 560 - tablieBodyScrollTop > h) {
          personTextboxAll[i].querySelector('.person-textbox').style.top = 'auto'
          personTextboxAll[i].querySelector('.person-textbox').style.bottom = '0'
        }
      } else {
        if (personTextboxAll[i].offsetLeft + 600 > w) {
          personTextboxAll[i].querySelector('.person-textbox').style.left =
              'auto'
          personTextboxAll[i].querySelector('.person-textbox').style.right =
              '90%'
        } else {
          personTextboxAll[i].querySelector('.person-textbox').style.left = '120px'
          personTextboxAll[i].querySelector('.person-textbox').style.right = 'auto'
        }
      }
    }
  }
}
</script>
<style lang="less" type="text/less">
  .del-doalog {
    width: 320px;
  }

  .icon-name_cont {
    position: relative;

    .invalid_flag {
      display: block;
      position: absolute;
      left: 10px;
      top: -3px;
      background-color: #7b7b7b;
      color: #fff;
      padding: 2px 5px;
      border-radius: 4px;
      z-index: 10;
    }
  }
</style>
<style lang="less" scoped>
  @import "~@/components/common/ProjectTable/Index.less";
  .listcnt{
    overflow: auto;
  }
  .content--options{
    /* 返回已删除人员列表 盒子样式 */
    .go-back{
      line-height: 24px;
      font-size: 20px;
      font-weight: 600;
      color: #212530;
      .r2-icon-hardware_keyboard_backspace_outlined{
        font-size: 24px;
        margin-top: -4px;
        margin-right: 6px;
      }
    }
  }
</style>

